import { Button, Col, Row, message } from 'antd';
import { isEmpty } from 'lodash';
import * as uuid from 'uuid';
import {
  IWidgetCsvCombination,
  IWidgetCsvConfig,
  IWidgetCsvField,
} from './WidgetCsvField';

export interface IImportCsvOptionsButtonProps {
  onImport: (config: IWidgetCsvConfig) => void;
  options?: IParseCsvOptions;
}

export interface IParseCsvOptions {
  /**
   * Di default sono obbligatori due campi (due colonne) per ogni riga.
   * Se è impostato a true, viene accettata anche una sola colonna.
   */
  allowOneColumn?: boolean;
}

function parseCsv(
  serialized: string,
  options: IParseCsvOptions = {},
): IWidgetCsvConfig | undefined {
  try {
    const rows = serialized
      .replace(/\r+/g, '')
      .split('\n')
      .map(i => i.split('\t'));

    const fields: IWidgetCsvField[] = rows[0].map((_, i) => ({
      label: `Colonna n.${i + 1}`,
      index: i,
      optionId: uuid.v4(), // Lo pregeneriamo
      order: i,
    }));

    const combinations: IWidgetCsvCombination[] = rows
      .map((row, _) => ({ values: row }))
      .filter(c => {
        if (isEmpty(c.values)) return false;
        if (!options?.allowOneColumn)
          return c.values[0] !== '' && c.values[1] !== '';
        return true;
      });

    return {
      fields,
      combinations,
    };
  } catch (e: any) {
    message.error('Si è verificato un errore nella lettura del CSV: ' + (e?.message ?? 'NA')); // prettier-ignore
    return undefined;
  }
}

export function ImportCsvOptionsButton(
  props: Readonly<IImportCsvOptionsButtonProps>,
) {
  const importCsv = () => {
    window.navigator.clipboard
      .readText()
      .then(serialized => {
        if (!serialized) {
          message.error('Nessun CSV trovato negli appunti.');
          return;
        }
        const config = parseCsv(serialized, props.options);
        if (!config) {
          message.error("Errore durante l'importazione del CSV.");
          return;
        }
        props.onImport(config);
        message.success('CSV importato con successo.');
      })
      .catch(error => {
        message.error(
          'Si è verificato un errore durante la lettura degli appunti.',
        );
      });
  };

  return (
    <Row
      align="middle"
      justify="start"
      style={{ marginBottom: '8px', marginTop: '16px' }}
    >
      <Col span={24}>
        <Button
          type="primary"
          block
          children="Incolla CSV"
          onClick={importCsv}
        />
      </Col>
    </Row>
  );
}
